module.exports = __webpack_public_path__ + "static/media/5.9f13e86e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/5.jpg
// module id = 993
// module chunks = 0